// src/pages/admin-appointments/admin-appointments.component.jsx
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectAppointments, selectAppointmentsLoading } from '../../redux/appointment/appointment.selectors';
import { fetchAppointments } from '../../redux/appointment/appointment.actions';
import './admin-appointments.styles.scss';

const AdminAppointments = ({ appointments, loading, fetchAppointments }) => {
  useEffect(() => {
    console.log('🔄 AdminAppointments mounted, fetching...'); // Debug log
    
    // Check if user is logged in
    const isLoggedIn = localStorage.getItem('adminLoggedIn');
    if (!isLoggedIn) {
      window.location.href = '/admin-login';
      return;
    }
    
    // Fetch appointments
    fetchAppointments();
  }, [fetchAppointments]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-PK', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return 'Invalid Date';
    }
  };

  const getServiceLabel = (service) => {
    const labels = {
      'hair-unit': 'Hair Unit / Patch',
      'hair-transplant': 'Hair Transplant',
      'consultation': 'Free Consultation'
    };
    return labels[service] || service || 'N/A';
  };

  const appointmentList = appointments || [];

  console.log('📊 AdminAppointments rendering with:', appointmentList.length, 'appointments'); // Debug log

  if (loading) {
    return (
      <div className="admin-appointments">
        <div className="loading-container">
          <div className="loader"></div>
          <p>Loading appointments...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-appointments">
      <div className="page-header">
        <h1>📋 Appointments</h1>
        <p>Manage all customer appointments</p>
        <div className="appointment-count">
          Total: {appointmentList.length} appointments
        </div>
      </div>

      {appointmentList.length === 0 ? (
        <div className="empty-state">
          <p>No appointments yet</p>
          <p className="sub-text">Appointments will appear here when customers book them.</p>
        </div>
      ) : (
        <div className="appointments-table-container">
          <table className="appointments-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Phone</th>
                <th>City</th>
                <th>Service</th>
                <th>Date</th>
                <th>Time</th>
                <th>Booked On</th>
              </tr>
            </thead>
            <tbody>
              {appointmentList.map((appointment, index) => (
                <tr key={appointment.id || index}>
                  <td>{index + 1}</td>
                  <td>{appointment.name || 'N/A'}</td>
                  <td>{appointment.phone || 'N/A'}</td>
                  <td>{appointment.city || 'N/A'}</td>
                  <td><span className="service-badge">{getServiceLabel(appointment.service)}</span></td>
                  <td>{appointment.date || 'N/A'}</td>
                  <td>{appointment.time || 'N/A'}</td>
                  <td>{formatDate(appointment.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  appointments: selectAppointments,
  loading: selectAppointmentsLoading
});

const mapDispatchToProps = (dispatch) => ({
  fetchAppointments: () => {
    console.log('🔄 Dispatching fetchAppointments...'); // Debug log
    dispatch(fetchAppointments());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminAppointments);